import { createWidget } from '@alfa-bank/site-util-create-widget';
import { DataLayer } from '@alfa-bank/site-data-layer';
import { TextDesktop as Text } from '@alfa-bank/site-text-v2/desktop';

import type { IDepsDesktop, TSectionLinkDesktop } from './models';
import { SectionLink as Component } from './section-link';
import styles from './desktop.css';
import { textConfigs } from './config';

export const SectionLinkDesktop = createWidget<IDepsDesktop, TSectionLinkDesktop>({
    DataLayer,
    styles,
    textConfigs,
    Text,
})(Component);
